import { useLocation } from "react-router-dom";

const SHIPMENT_ROUTE_PATTERN = /^\/shipments\/(\d+)(?:[/?#]|$)/;

/**
 * Derives the chat channel currently in view from the URL.
 *
 * Returns the channel name if the route maps to a known chat (today only the
 * shipment overview surfaces an embedded chat panel). Returns null otherwise.
 *
 * The realtime listener uses this to suppress unread bumps for the channel the
 * user is actively viewing. Centralizing the route-to-channel mapping here so
 * future channel types extend in one place.
 */
export function useCurrentlyOpenChatChannel(): string | null {
  const { pathname } = useLocation();
  const match = SHIPMENT_ROUTE_PATTERN.exec(pathname);
  if (match === null) return null;
  const shipmentId = match[1];
  return `shipment.booked.${shipmentId}`;
}
